import { memo } from 'react';

import { MessageBubble } from '@/pages/messaging/components/MessageBubble';

import type { MessagingMessage } from '@/lib/api/messaging.api';
import type { TimelineMessageItem } from '@repo/shared-types';

/** MessageBubble consumes the messaging API shape; adapt a timeline item. */
const toMessagingMessage = (item: TimelineMessageItem): MessagingMessage => ({
  id: item.id,
  conversation_id: item.conversation_id,
  direction: item.direction,
  status: item.status,
  type: item.type as MessagingMessage['type'],
  content: item.content,
  media_url: item.media_url,
  channel_message_id: null,
  sender_id: item.sender_id ?? null,
  metadata: null,
  error_message: item.error_message ?? null,
  created_at: item.timestamp,
  updated_at: item.timestamp,
  reply_to_message_id: item.reply_to_message_id ?? null,
  reply_to_content: item.reply_to_content ?? null,
  reply_to_direction: item.reply_to_direction ?? null,
});

/**
 * Memoized on the timeline item reference (React Query structurally shares
 * unchanged items across refetches), so a parent re-render — drag feedback,
 * flash, live indicator, socket invalidation — doesn't rebuild every bubble.
 */
const TimelineMessageBubbleComponent = ({
  item,
  compact,
}: {
  item: TimelineMessageItem;
  compact?: boolean;
}) => <MessageBubble message={toMessagingMessage(item)} compact={compact} />;

export const TimelineMessageBubble = memo(TimelineMessageBubbleComponent);
